import { UserRole } from '@/store/auth/types';
import { ServiceProviderType } from 'types';
import { CalculatedTableColumn } from '../types';
import { getColumns } from './columns';

export const getGridColumns = (props: IGridColumnProps, screenWidth: number): CalculatedTableColumn[] => {
  const visibleColumns = getColumns(props)
    .filter(col => col.visible({ role: props.userRole, serviceProviderType: props.serviceProviderType }))
    .map(col => col.item);

  const columnsWithoutAsignedWidth = visibleColumns.filter(col => {
    const width = Number(col.width);
    if (width) {
      screenWidth -= width;

      return false;
    }
    return true;
  }).length;
  const equalWidth = Math.round((screenWidth - 100) / columnsWithoutAsignedWidth);

  return visibleColumns.map(col => {
    if (col.width === undefined && col.responsive !== true) {
      col.width = String(equalWidth);
    }
    col.headerCellClass = `grid-HeaderCell rdg-column-${col.key}`;
    col.cellClass = (): string => `row grid-Cell`;
    return col;
  });
};

export interface IGridColumnProps {
  userRole: UserRole;
  serviceProviderType?: ServiceProviderType;
  activeTab: string;
}

export const getColumnsForActiveTab = (
  { userRole, serviceProviderType, activeTab }: IGridColumnProps,
  screenWidth: number,
): CalculatedTableColumn[] => {
  const columns = getGridColumns({ userRole, serviceProviderType, activeTab }, screenWidth);

  return columns;
};
